module.exports = __webpack_public_path__ + "img/tu-2_24.0145bb3f.jpg";